<template>
  <div>
    <beast-header/>
    <router-view></router-view>
    <beast-footer/>
  </div>
</template>
<script>
import BeastHeader from "../../components/header/BeastHeader.vue";
import BeastFooter from "../../components/footer/BeastFooter.vue";

export default {
  components: { BeastFooter, BeastHeader },
  data() {
    return {
      model: {
        username: "",
        password: "",
        rememberMe: false
      },
      hasErrors: false,
      errorMessage: ""
    };
  },
  methods: {
    handleLogin() {
      this.hasErrors = false;

      this.$auth
        .login({
          data: {
            username: this.model.username,
            password: this.model.password,
            rememberMe: this.model.rememberMe
          },
          rememberMe: this.model.rememberMe,
          redirect: "/"
        })
        .catch((error) => {
          this.hasErrors = true;
          if (error.response) {
            this.errorMessage = error.response.data.message;
          } else {
            this.errorMessage = error;
          }
        });
    }
  }
};
</script>
<style scoped>
  .navbar-nav .nav-item p {
    line-height: inherit;
    margin-left: 5px;
  }
</style>
